import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { clienteService } from "@/services/api/cliente.service";
import { CreateClientePayload, UpdateClientePayload } from "@/types/cliente.type";

export function useClienteActions() {
  const queryClient = useQueryClient();

  const invalidateQueriesGlobally = () => {
    // Invalida a lista e os KPIs simultaneamente
    queryClient.invalidateQueries({ queryKey: ["clientes-matriz-list"] });
    queryClient.invalidateQueries({ queryKey: ["clientes-resumo-totais"] });
  };

  const onSuccessAction = (mensagem: string) => {
    invalidateQueriesGlobally();
    toast.success(mensagem);
  };

  const onErrorAction = (error: any, defaultMessage: string) => {
    console.error(defaultMessage, error);
  };

  const createMutation = useMutation({
    mutationFn: (data: CreateClientePayload) => clienteService.createCliente(data),
    onSuccess: () => onSuccessAction("Cliente cadastrado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao cadastrar cliente."),
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateClientePayload }) =>
      clienteService.updateCliente(id, data),
    onSuccess: () => onSuccessAction("Cliente atualizado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao atualizar cliente."),
  });

  const inactivateMutation = useMutation({
    mutationFn: (id: number) => clienteService.inactivateCliente(id),
    onSuccess: () => onSuccessAction("Cliente inativado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao inativar cliente."),
  });

  const reactivateMutation = useMutation({
    mutationFn: (id: number) => clienteService.reactivateCliente(id),
    onSuccess: () => onSuccessAction("Cliente reativado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao reativar cliente."),
  });

  return {
    isCreating: createMutation.isPending,
    isUpdating: updateMutation.isPending,
    isTogglingStatus: inactivateMutation.isPending || reactivateMutation.isPending,
    createCliente: createMutation.mutateAsync,
    updateCliente: updateMutation.mutateAsync,
    inactivateCliente: inactivateMutation.mutateAsync,
    reactivateCliente: reactivateMutation.mutateAsync,
  };
}
